"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "ui:layout": "section",
  "ui:title": "Bygningsdel",
  "ui:label": false,
  "ui:preview": {
    "select": {
      "description": "description"
    },

    prepare({
      formData,
      schema
    }) {
      const buildingPartId = formData.buildingPartId;
      let description;

      if (buildingPartId && schema.properties.buildingPartId.enum && schema.properties.buildingPartId.enumNames) {
        const index = schema.properties.buildingPartId.enum.indexOf(buildingPartId);
        description = schema.properties.buildingPartId.enumNames[index] || index;
      }

      return {
        description: description
      };
    }

  },
  "ui:options": {
    "grid": true,
    "spacing": 2,
    "collapsible": true
  },
  "ui:fieldset": ["buildingPartId", "buildingDetails", "type"],
  "type": {
    "ui:title": "Type avvik",
    "ui:widget": "radio"
  },
  "buildingPartId": {
    "ui:title": "Bygningsdel",
    "ui:placeholder": "Søk og velg bygningsdel",
    "ui:widget": "autocomplete"
  },
  "buildingDetails": {
    "ui:title": "Posisjon",
    "ui:widget": "textarea",
    "ui:help": "Hvor på bygningen er avviket?"
  }
};
exports.default = _default;
module.exports = exports.default;